import React from 'react';
import { useSelector } from 'react-redux';
import { Box, Masthead, Stack, useTokens } from '@barracuda-internal/bds-core';

import NavigationPanel from './NavigationPanel';

/**
 * Support SPA shell — left NavigationBar (icons + labels) + Masthead +
 * scrollable content area. Nav routes and profile menu live in
 * NavigationPanel. The peek-mode account picker is NOT rendered here — it
 * appears only inside AdminDashboard, since peek only makes sense on the
 * dashboard.
 */
const WrapperContainer = ({ children }) => {
  const tokens = useTokens();
  const username = useSelector((s) => s.auth.username);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        height: '100vh',
        width: '100%',
        backgroundColor: tokens.aliasesColorBgPageDefault,
      }}
    >
      <NavigationPanel />

      <Stack sx={{ height: '100vh', flex: 1, minWidth: 0 }}>
        <Masthead
          productTitle="Prompt Security"
          pageTitle="Support"
          userEmail={username || undefined}
        />
        <Box
          sx={{
            flex: 1,
            minHeight: 0,
            overflow: 'auto',
            padding: tokens.aliasesSpaceContainerSpacious,
          }}
        >
          {children}
        </Box>
      </Stack>
    </Box>
  );
};

export default WrapperContainer;
